/* @generated from adl module PluginInterface */

import * as ADL from './runtime/adl';
import * as Buffer from './Buffer';
import * as ClientState from './ClientState';
import * as CodeDiagnostics from './CodeDiagnostics';
import * as InfoRequest from './InfoRequest';
import * as Path from './Path';
import * as PluginTypes from './PluginTypes';
import * as SyntaxHighlighting from './SyntaxHighlighting';

export interface WorkspaceSourceFileTree {
  workspaceVersion: PluginTypes.WorkspaceVersion;
  sourceFiles: WorkspaceSourceFile[];
}

export function makeWorkspaceSourceFileTree(
  input: {
    workspaceVersion: PluginTypes.WorkspaceVersion,
    sourceFiles: WorkspaceSourceFile[],
  }
): WorkspaceSourceFileTree {
  return {
    workspaceVersion: input.workspaceVersion,
    sourceFiles: input.sourceFiles,
  };
}

const WorkspaceSourceFileTree_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workspaceVersion","default":{"kind":"nothing"},"name":"workspaceVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginTypes","name":"WorkspaceVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"sourceFiles","default":{"kind":"nothing"},"name":"sourceFiles","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"WorkspaceSourceFile"}},"parameters":[]}]}}]}},"name":"WorkspaceSourceFileTree","version":{"kind":"nothing"}}};

export const snWorkspaceSourceFileTree: ADL.ScopedName = {moduleName:"PluginInterface", name:"WorkspaceSourceFileTree"};

export function texprWorkspaceSourceFileTree(): ADL.ATypeExpr<WorkspaceSourceFileTree> {
  return {value : {typeRef : {kind: "reference", value : snWorkspaceSourceFileTree}, parameters : []}};
}

export interface WorkspaceSourceFile {
  version: ClientState.EditorFileVersion;
  filePath: Path.PathRelFile;
  contents: string;
}

export function makeWorkspaceSourceFile(
  input: {
    version: ClientState.EditorFileVersion,
    filePath: Path.PathRelFile,
    contents: string,
  }
): WorkspaceSourceFile {
  return {
    version: input.version,
    filePath: input.filePath,
    contents: input.contents,
  };
}

const WorkspaceSourceFile_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}},{"annotations":[],"serializedName":"contents","default":{"kind":"nothing"},"name":"contents","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"WorkspaceSourceFile","version":{"kind":"nothing"}}};

export const snWorkspaceSourceFile: ADL.ScopedName = {moduleName:"PluginInterface", name:"WorkspaceSourceFile"};

export function texprWorkspaceSourceFile(): ADL.ATypeExpr<WorkspaceSourceFile> {
  return {value : {typeRef : {kind: "reference", value : snWorkspaceSourceFile}, parameters : []}};
}

export interface PluginEvent {
  workspaceVersion: PluginTypes.WorkspaceVersion;
  value: PluginEventValue;
}

export function makePluginEvent(
  input: {
    workspaceVersion: PluginTypes.WorkspaceVersion,
    value: PluginEventValue,
  }
): PluginEvent {
  return {
    workspaceVersion: input.workspaceVersion,
    value: input.value,
  };
}

const PluginEvent_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workspaceVersion","default":{"kind":"nothing"},"name":"workspaceVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginTypes","name":"WorkspaceVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"PluginEventValue"}},"parameters":[]}}]}},"name":"PluginEvent","version":{"kind":"nothing"}}};

export const snPluginEvent: ADL.ScopedName = {moduleName:"PluginInterface", name:"PluginEvent"};

export function texprPluginEvent(): ADL.ATypeExpr<PluginEvent> {
  return {value : {typeRef : {kind: "reference", value : snPluginEvent}, parameters : []}};
}

export interface PluginEventValue_PluginWorkspaceChange {
  kind: 'pluginWorkspaceChange';
  value: PluginWorkspaceChange;
}
export interface PluginEventValue_InfoRequest {
  kind: 'infoRequest';
  value: PluginInfoRequest;
}

export type PluginEventValue = PluginEventValue_PluginWorkspaceChange | PluginEventValue_InfoRequest;

export interface PluginEventValueOpts {
  pluginWorkspaceChange: PluginWorkspaceChange;
  infoRequest: PluginInfoRequest;
}

export function makePluginEventValue<K extends keyof PluginEventValueOpts>(kind: K, value: PluginEventValueOpts[K]) { return {kind, value}; }

const PluginEventValue_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"pluginWorkspaceChange","default":{"kind":"nothing"},"name":"pluginWorkspaceChange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"PluginWorkspaceChange"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequest","default":{"kind":"nothing"},"name":"infoRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"PluginInfoRequest"}},"parameters":[]}}]}},"name":"PluginEventValue","version":{"kind":"nothing"}}};

export const snPluginEventValue: ADL.ScopedName = {moduleName:"PluginInterface", name:"PluginEventValue"};

export function texprPluginEventValue(): ADL.ATypeExpr<PluginEventValue> {
  return {value : {typeRef : {kind: "reference", value : snPluginEventValue}, parameters : []}};
}

export interface PluginWorkspaceChange_SourceFileChange {
  kind: 'sourceFileChange';
  value: SourceFileChange;
}
export interface PluginWorkspaceChange_SourceFileAdd {
  kind: 'sourceFileAdd';
  value: SourceFileAdd;
}
export interface PluginWorkspaceChange_SourceFileRemove {
  kind: 'sourceFileRemove';
  value: SourceFileRemove;
}

export type PluginWorkspaceChange = PluginWorkspaceChange_SourceFileChange | PluginWorkspaceChange_SourceFileAdd | PluginWorkspaceChange_SourceFileRemove;

export interface PluginWorkspaceChangeOpts {
  sourceFileChange: SourceFileChange;
  sourceFileAdd: SourceFileAdd;
  sourceFileRemove: SourceFileRemove;
}

export function makePluginWorkspaceChange<K extends keyof PluginWorkspaceChangeOpts>(kind: K, value: PluginWorkspaceChangeOpts[K]) { return {kind, value}; }

const PluginWorkspaceChange_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceFileChange","default":{"kind":"nothing"},"name":"sourceFileChange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"SourceFileChange"}},"parameters":[]}},{"annotations":[],"serializedName":"sourceFileAdd","default":{"kind":"nothing"},"name":"sourceFileAdd","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"SourceFileAdd"}},"parameters":[]}},{"annotations":[],"serializedName":"sourceFileRemove","default":{"kind":"nothing"},"name":"sourceFileRemove","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"SourceFileRemove"}},"parameters":[]}}]}},"name":"PluginWorkspaceChange","version":{"kind":"nothing"}}};

export const snPluginWorkspaceChange: ADL.ScopedName = {moduleName:"PluginInterface", name:"PluginWorkspaceChange"};

export function texprPluginWorkspaceChange(): ADL.ATypeExpr<PluginWorkspaceChange> {
  return {value : {typeRef : {kind: "reference", value : snPluginWorkspaceChange}, parameters : []}};
}

export interface PluginInfoRequest {
  id: InfoRequest.InfoRequestId;
  infoRequest: InfoRequest.InfoRequest;
}

export function makePluginInfoRequest(
  input: {
    id: InfoRequest.InfoRequestId,
    infoRequest: InfoRequest.InfoRequest,
  }
): PluginInfoRequest {
  return {
    id: input.id,
    infoRequest: input.infoRequest,
  };
}

const PluginInfoRequest_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequest","default":{"kind":"nothing"},"name":"infoRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequest"}},"parameters":[]}}]}},"name":"PluginInfoRequest","version":{"kind":"nothing"}}};

export const snPluginInfoRequest: ADL.ScopedName = {moduleName:"PluginInterface", name:"PluginInfoRequest"};

export function texprPluginInfoRequest(): ADL.ATypeExpr<PluginInfoRequest> {
  return {value : {typeRef : {kind: "reference", value : snPluginInfoRequest}, parameters : []}};
}

export interface SourceFileChange {
  filePath: Path.PathRelFile;
  version: ClientState.EditorFileVersion;
  changes: Buffer.BufferChange[];
}

export function makeSourceFileChange(
  input: {
    filePath: Path.PathRelFile,
    version: ClientState.EditorFileVersion,
    changes: Buffer.BufferChange[],
  }
): SourceFileChange {
  return {
    filePath: input.filePath,
    version: input.version,
    changes: input.changes,
  };
}

const SourceFileChange_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"changes","default":{"kind":"nothing"},"name":"changes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Buffer","name":"BufferChange"}},"parameters":[]}]}}]}},"name":"SourceFileChange","version":{"kind":"nothing"}}};

export const snSourceFileChange: ADL.ScopedName = {moduleName:"PluginInterface", name:"SourceFileChange"};

export function texprSourceFileChange(): ADL.ATypeExpr<SourceFileChange> {
  return {value : {typeRef : {kind: "reference", value : snSourceFileChange}, parameters : []}};
}

export interface SourceFileAdd {
  file: WorkspaceSourceFile;
}

export function makeSourceFileAdd(
  input: {
    file: WorkspaceSourceFile,
  }
): SourceFileAdd {
  return {
    file: input.file,
  };
}

const SourceFileAdd_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"file","default":{"kind":"nothing"},"name":"file","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"WorkspaceSourceFile"}},"parameters":[]}}]}},"name":"SourceFileAdd","version":{"kind":"nothing"}}};

export const snSourceFileAdd: ADL.ScopedName = {moduleName:"PluginInterface", name:"SourceFileAdd"};

export function texprSourceFileAdd(): ADL.ATypeExpr<SourceFileAdd> {
  return {value : {typeRef : {kind: "reference", value : snSourceFileAdd}, parameters : []}};
}

export interface SourceFileRemove {
  filePath: Path.PathRelFile;
}

export function makeSourceFileRemove(
  input: {
    filePath: Path.PathRelFile,
  }
): SourceFileRemove {
  return {
    filePath: input.filePath,
  };
}

const SourceFileRemove_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}}]}},"name":"SourceFileRemove","version":{"kind":"nothing"}}};

export const snSourceFileRemove: ADL.ScopedName = {moduleName:"PluginInterface", name:"SourceFileRemove"};

export function texprSourceFileRemove(): ADL.ATypeExpr<SourceFileRemove> {
  return {value : {typeRef : {kind: "reference", value : snSourceFileRemove}, parameters : []}};
}

export interface LanguageEngineResult {
  workspaceVersion: PluginTypes.WorkspaceVersion;
  value: LanguageEngineResultValue;
}

export function makeLanguageEngineResult(
  input: {
    workspaceVersion: PluginTypes.WorkspaceVersion,
    value: LanguageEngineResultValue,
  }
): LanguageEngineResult {
  return {
    workspaceVersion: input.workspaceVersion,
    value: input.value,
  };
}

const LanguageEngineResult_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"workspaceVersion","default":{"kind":"nothing"},"name":"workspaceVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginTypes","name":"WorkspaceVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"LanguageEngineResultValue"}},"parameters":[]}}]}},"name":"LanguageEngineResult","version":{"kind":"nothing"}}};

export const snLanguageEngineResult: ADL.ScopedName = {moduleName:"PluginInterface", name:"LanguageEngineResult"};

export function texprLanguageEngineResult(): ADL.ATypeExpr<LanguageEngineResult> {
  return {value : {typeRef : {kind: "reference", value : snLanguageEngineResult}, parameters : []}};
}

export interface LanguageEngineResultValue_FileSyntaxHighlighting {
  kind: 'fileSyntaxHighlighting';
  value: FileSyntaxHighlighting;
}
export interface LanguageEngineResultValue_CodeDiagnosticsUpdate {
  kind: 'codeDiagnosticsUpdate';
  value: CodeDiagnosticsUpdate;
}
export interface LanguageEngineResultValue_InfoResponse {
  kind: 'infoResponse';
  value: InfoResponse;
}

export type LanguageEngineResultValue = LanguageEngineResultValue_FileSyntaxHighlighting | LanguageEngineResultValue_CodeDiagnosticsUpdate | LanguageEngineResultValue_InfoResponse;

export interface LanguageEngineResultValueOpts {
  fileSyntaxHighlighting: FileSyntaxHighlighting;
  codeDiagnosticsUpdate: CodeDiagnosticsUpdate;
  infoResponse: InfoResponse;
}

export function makeLanguageEngineResultValue<K extends keyof LanguageEngineResultValueOpts>(kind: K, value: LanguageEngineResultValueOpts[K]) { return {kind, value}; }

const LanguageEngineResultValue_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fileSyntaxHighlighting","default":{"kind":"nothing"},"name":"fileSyntaxHighlighting","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"FileSyntaxHighlighting"}},"parameters":[]}},{"annotations":[],"serializedName":"codeDiagnosticsUpdate","default":{"kind":"nothing"},"name":"codeDiagnosticsUpdate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"CodeDiagnosticsUpdate"}},"parameters":[]}},{"annotations":[],"serializedName":"infoResponse","default":{"kind":"nothing"},"name":"infoResponse","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginInterface","name":"InfoResponse"}},"parameters":[]}}]}},"name":"LanguageEngineResultValue","version":{"kind":"nothing"}}};

export const snLanguageEngineResultValue: ADL.ScopedName = {moduleName:"PluginInterface", name:"LanguageEngineResultValue"};

export function texprLanguageEngineResultValue(): ADL.ATypeExpr<LanguageEngineResultValue> {
  return {value : {typeRef : {kind: "reference", value : snLanguageEngineResultValue}, parameters : []}};
}

export interface FileSyntaxHighlighting {
  filePath: Path.PathRelFile;
  version: ClientState.EditorFileVersion;
  syntaxHighlightingSpans: SyntaxHighlighting.SyntaxHighlightingSpan[];
}

export function makeFileSyntaxHighlighting(
  input: {
    filePath: Path.PathRelFile,
    version: ClientState.EditorFileVersion,
    syntaxHighlightingSpans: SyntaxHighlighting.SyntaxHighlightingSpan[],
  }
): FileSyntaxHighlighting {
  return {
    filePath: input.filePath,
    version: input.version,
    syntaxHighlightingSpans: input.syntaxHighlightingSpans,
  };
}

const FileSyntaxHighlighting_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filePath","default":{"kind":"nothing"},"name":"filePath","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Path","name":"PathRelFile"}},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"syntaxHighlightingSpans","default":{"kind":"nothing"},"name":"syntaxHighlightingSpans","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"SyntaxHighlighting","name":"SyntaxHighlightingSpan"}},"parameters":[]}]}}]}},"name":"FileSyntaxHighlighting","version":{"kind":"nothing"}}};

export const snFileSyntaxHighlighting: ADL.ScopedName = {moduleName:"PluginInterface", name:"FileSyntaxHighlighting"};

export function texprFileSyntaxHighlighting(): ADL.ATypeExpr<FileSyntaxHighlighting> {
  return {value : {typeRef : {kind: "reference", value : snFileSyntaxHighlighting}, parameters : []}};
}

export interface CodeDiagnosticsUpdate {
  codeDiagnostics: CodeDiagnostics.CodeDiagnostic[];
}

export function makeCodeDiagnosticsUpdate(
  input: {
    codeDiagnostics: CodeDiagnostics.CodeDiagnostic[],
  }
): CodeDiagnosticsUpdate {
  return {
    codeDiagnostics: input.codeDiagnostics,
  };
}

const CodeDiagnosticsUpdate_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"codeDiagnostics","default":{"kind":"nothing"},"name":"codeDiagnostics","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"CodeDiagnostics","name":"CodeDiagnostic"}},"parameters":[]}]}}]}},"name":"CodeDiagnosticsUpdate","version":{"kind":"nothing"}}};

export const snCodeDiagnosticsUpdate: ADL.ScopedName = {moduleName:"PluginInterface", name:"CodeDiagnosticsUpdate"};

export function texprCodeDiagnosticsUpdate(): ADL.ATypeExpr<CodeDiagnosticsUpdate> {
  return {value : {typeRef : {kind: "reference", value : snCodeDiagnosticsUpdate}, parameters : []}};
}

export interface InfoResponse {
  id: InfoRequest.InfoRequestId;
  infoRequestResult: InfoRequest.InfoRequestResult;
}

export function makeInfoResponse(
  input: {
    id: InfoRequest.InfoRequestId,
    infoRequestResult: InfoRequest.InfoRequestResult,
  }
): InfoResponse {
  return {
    id: input.id,
    infoRequestResult: input.infoRequestResult,
  };
}

const InfoResponse_AST : ADL.ScopedDecl =
  {"moduleName":"PluginInterface","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequestResult","default":{"kind":"nothing"},"name":"infoRequestResult","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequestResult"}},"parameters":[]}}]}},"name":"InfoResponse","version":{"kind":"nothing"}}};

export const snInfoResponse: ADL.ScopedName = {moduleName:"PluginInterface", name:"InfoResponse"};

export function texprInfoResponse(): ADL.ATypeExpr<InfoResponse> {
  return {value : {typeRef : {kind: "reference", value : snInfoResponse}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "PluginInterface.WorkspaceSourceFileTree" : WorkspaceSourceFileTree_AST,
  "PluginInterface.WorkspaceSourceFile" : WorkspaceSourceFile_AST,
  "PluginInterface.PluginEvent" : PluginEvent_AST,
  "PluginInterface.PluginEventValue" : PluginEventValue_AST,
  "PluginInterface.PluginWorkspaceChange" : PluginWorkspaceChange_AST,
  "PluginInterface.PluginInfoRequest" : PluginInfoRequest_AST,
  "PluginInterface.SourceFileChange" : SourceFileChange_AST,
  "PluginInterface.SourceFileAdd" : SourceFileAdd_AST,
  "PluginInterface.SourceFileRemove" : SourceFileRemove_AST,
  "PluginInterface.LanguageEngineResult" : LanguageEngineResult_AST,
  "PluginInterface.LanguageEngineResultValue" : LanguageEngineResultValue_AST,
  "PluginInterface.FileSyntaxHighlighting" : FileSyntaxHighlighting_AST,
  "PluginInterface.CodeDiagnosticsUpdate" : CodeDiagnosticsUpdate_AST,
  "PluginInterface.InfoResponse" : InfoResponse_AST
};
